module.exports = __webpack_public_path__ + "img/s10.7a29f80.png";